import { Injectable, inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as actions from '../actions/landing-pages.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { LandingPagesService } from '../../services';
import { Go } from 'src/app/store';

export const LoadLandingPages$ = createEffect(
  (actions$ = inject(Actions), service = inject(LandingPagesService)) => {
    return actions$.pipe(
      ofType(actions.LoadLandingPages),
      switchMap(() =>
        service.getPages().pipe(
          map(landingPages => actions.LoadLandingPagesSuccess({ landingPages })),
          catchError(error => of(actions.LoadLandingPagesFail({ error })))
        )
      )
    );
  },
  { functional: true }
);

export const LoadLandingPageBySlug$ = createEffect(
  (actions$ = inject(Actions), service = inject(LandingPagesService)) => {
    return actions$.pipe(
      ofType(actions.LoadLandingPageBySlug),
      switchMap(({ slug }) =>
        service.getPageBySlug(slug).pipe(
          map(page => actions.LoadLandingPageBySlugSuccess({ page })),
          catchError(error => of(actions.LoadLandingPageBySlugFail({ error, slug })))
        )
      )
    );
  },
  { functional: true }
);

export const LoadLandingPageById$ = createEffect(
  (actions$ = inject(Actions), service = inject(LandingPagesService)) => {
    return actions$.pipe(
      ofType(actions.LoadLandingPageById),
      switchMap(({ id }) =>
        service.getPageById(id).pipe(
          map(page => actions.LoadLandingPageByIdSuccess({ page })),
          catchError(error => of(actions.LoadLandingPageByIdFail({ error })))
        )
      )
    );
  },
  { functional: true }
);

export const LoadBySlugFail$ = createEffect(
  (actions$ = inject(Actions)) => {
    return actions$.pipe(
      ofType(actions.LoadLandingPageBySlugFail),
      map(({ error }) => {
        return Go({ path: ['/' + error?.status ? error.status : '404'], extras: { skipLocationChange: true } });
      })
    );
  },
  { functional: true }
);

export const LoadByIdFail$ = createEffect(
  (actions$ = inject(Actions)) => {
    return actions$.pipe(
      ofType(actions.LoadLandingPageByIdFail),
      map(({ error }) => {
        return Go({ path: ['/' + error?.status ? error.status : '404'], extras: { skipLocationChange: true } });
      })
    );
  },
  { functional: true }
);
